var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNonStandardEquipment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Non-Standard_Equipment_"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Non-Standard_Equipment_",
    "data-name": "Non-Standard Equipment ",
    clipPath: "url(#clip-Non-Standard_Equipment_)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7591",
    "data-name": "Rectangle 7591",
    width: 27,
    height: 26.995,
    rx: 6,
    transform: "translate(0.5 0.502)",
    fill: "#ac4399"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9009",
    "data-name": "Group 9009",
    transform: "translate(-0.775 0.013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9010",
    "data-name": "Group 9010"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9006",
    "data-name": "Group 9006",
    transform: "translate(18509.688 -13141.285)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19043",
    "data-name": "Path 19043",
    d: "M4-.1A3.328,3.328,0,0,1,7.354,3.336,3.192,3.192,0,0,1,4,6.609,3.322,3.322,0,0,1,.6,3.222,3.271,3.271,0,0,1,4-.1Z",
    transform: "translate(-18497.965 13155.748)",
    fill: "rgba(255,255,255,0.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19044",
    "data-name": "Path 19044",
    d: "M341.313,69.043a1.279,1.279,0,0,1-.867-.348c-.471-.46-.944-.919-1.4-1.4a1.319,1.319,0,0,1-.019-1.764c.229-.26.48-.5.731-.74a.442.442,0,0,1,.647.036q.669.664,1.334,1.333.576.576,1.152,1.152a.464.464,0,0,1,0,.736c-.195.2-.389.393-.587.586A1.375,1.375,0,0,1,341.313,69.043Zm.652-1.328-1.936-1.94-.242.268c-.024.026-.051.049-.072.076a.439.439,0,0,0,.022.592q.643.656,1.3,1.3a.437.437,0,0,0,.614.006C341.761,67.917,341.866,67.809,341.965,67.715Z",
    transform: "translate(-18830.041 13082.105)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19045",
    "data-name": "Path 19045",
    d: "M179.424,260.98v-.468c0-.026.01-.052.014-.078.018-.128.028-.257.053-.383a3.686,3.686,0,0,1,1.56-2.383,3.626,3.626,0,0,1,2.745-.613,3.552,3.552,0,0,1,1.867.906,3.654,3.654,0,0,1,1.219,3.282,3.59,3.59,0,0,1-1.045,2.125,3.674,3.674,0,0,1-2.028,1.068c-.134.023-.269.038-.4.057h-.468a.305.305,0,0,0-.049-.012,3.6,3.6,0,0,1-1.77-.608,3.71,3.71,0,0,1-1.636-2.48C179.456,261.256,179.443,261.118,179.424,260.98Zm3.757-3.088a2.9,2.9,0,0,0-1.328.322,2.849,2.849,0,0,0-1.154,3.948.224.224,0,0,0,.386.05l3.549-3.548a.225.225,0,0,0-.05-.391A2.839,2.839,0,0,0,183.181,257.893Zm2.843,2.851a2.812,2.812,0,0,0-.379-1.409.223.223,0,0,0-.389-.051l-3.548,3.548a.222.222,0,0,0,.052.388,2.791,2.791,0,0,0,1.94.329A2.85,2.85,0,0,0,186.024,260.744Z",
    transform: "translate(-18677.148 12898.275)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19046",
    "data-name": "Path 19046",
    d: "M67.884,243.78a4.442,4.442,0,0,1,1.456-3.294,1.084,1.084,0,0,1-1.6-.429c-.064-.125-.12-.254-.181-.381a.455.455,0,0,0-.775-.152q-.414.386-.811.789a6.643,6.643,0,0,0-1.863,3.627c-.043.252-.072.506-.107.759v.875a3.528,3.528,0,0,0,.067.428c.1.371.216.739.334,1.105a.467.467,0,0,0,.295.281,4.618,4.618,0,0,0,1.421.365.479.479,0,0,1,.086.023h.875a1.037,1.037,0,0,1,.13-.027,7,7,0,0,0,2.254-.568A4.444,4.444,0,0,1,67.884,243.78Z",
    transform: "translate(-18567.412 12915.449)",
    fill: "rgba(255,255,255,0.3)",
    stroke: "#fff",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19047",
    "data-name": "Path 19047",
    d: "M235.592,150.231c.839-.839,1.923-1.687,2.764-2.529l-1.389-1.388c-1.334,1.334-2.956,2.6-4.271,3.917a4.446,4.446,0,0,1,1.526-.268A4.829,4.829,0,0,1,235.592,150.231Z",
    transform: "translate(-18728.59 13003.751)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonStandardEquipment);
export default __webpack_public_path__ + "static/media/Non-Standard Equipment.38c3ff605361f07a018d58e6e7ddac2d.svg";
export { ForwardRef as ReactComponent };